import {PaymentType} from './payment-type';

export const PaymentModel = {
    bankTransfer: {paymentType: PaymentType.BANK_TRANSFER , price: 0},
    proforma: {paymentType: PaymentType.PROFORMA , price: 75}
};
